<div *ngIf="!isLoading && data" fxLayout="column" fxLayoutAlign="center center" class="chart">
  <div>
    <ngx-charts-bar-vertical-stacked
      #chart
      [results]="data"
      [scheme]="{ domain: this.colors }"
      [legend]="false"
      [xAxis]="true"
      [yAxis]="true"
      [yAxisTickFormatting]="toIntegerAxis"
      [barPadding]="barPadding"
    >
      <ng-template #tooltipTemplate let-model="model">
        <span slot="tooltip" class="chart__tooltip">
          <h4>{{ 'DEADLINES.CARDS.RESPONSE.TITLE' | translate }}</h4>
          <p>{{ 'DEADLINES.CARDS.FILTERS.LEGENDS.ON' | translate }}: {{ model.onPeriodCount }}</p>
          <p>{{ 'DEADLINES.CARDS.FILTERS.LEGENDS.OUT' | translate }}: {{ model.outPeriodCount }}</p>
        </span>
      </ng-template>
    </ngx-charts-bar-vertical-stacked>
  </div>

  <ng-content select="[slot='legend']"></ng-content>
</div>

<ngx-skeleton-loader
  *ngIf="isLoading || !data"
  [theme]="{
    height: '100%',
    width: '100%',
    margin: '0'
  }"
>
</ngx-skeleton-loader>
